const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateCheckoutInput(fullName, email) {
  if (!fullName?.trim()) {
    return "Please enter your full name.";
  }
  if (!email?.trim()) {
    return "Please enter your email address.";
  }
  if (!emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  return null;
}
